export const HOME = require("./Home.png");
export const HOME_ACTIVE = require("./HomeActive.png");
export const CREATE = require("./CreatePost.png");
export const CREATE_ACTIVE = require("./CreatePostActive.png");
export const CHAT = require("./ChatIcon.png");
export const CHAT_ACTIVE = require("./ChatActive.png");
export const SEARCH = require("./SearchIcon.png");
export const SEARCH_ACTIVE = require("./SearchActive.png");
export const BELL = require("./bell.png");
export const SETTINGS = require("./settings.png");
export const DOWN = require("./down.png");
export const SEARCHICON = require("./Search-Icon.png");
